export default __webpack_public_path__ + "static/small-business-economy-accomplishment-1a-3f90a33b6cdf28685e43efa34f1261cb.webp";